import { GoogleAuthProvider } from 'firebase/auth';

// The Google provider, as every Google sign-in in this app asks for it (#567):
// signing in or up (AuthContext) and proving it is still you before Delete
// Account (data/accountDeletion.js).
//
// `prompt: 'select_account'` so that a browser signed in to more than one
// Google account asks which one, every time. Without it Google picks the last
// one used. For signing in that is a studio quietly made under the wrong
// account; for a deletion it is a re-authentication that fails as "not the
// account you sign in with" without the teacher ever being asked.
//
// A new provider per call, because `setCustomParameters` mutates it.
export function googleProvider() {
  const provider = new GoogleAuthProvider();
  provider.setCustomParameters({ prompt: 'select_account' });
  return provider;
}
